import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL;
const LOGIN_BYPASS_ENABLED = true;
const LOGIN_BYPASS_CREDENTIALS = {
  username: "admin",
  password: "@dmin$202627",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = useCallback(async (username, password) => {
    const res = await axios.post(`${API}/api/auth/login`, { username, password }, { withCredentials: true });
    setUser(res.data.user);
    return res.data;
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
      setUser(res.data);
      return true;
    } catch {
      if (LOGIN_BYPASS_ENABLED) {
        try {
          await login(LOGIN_BYPASS_CREDENTIALS.username, LOGIN_BYPASS_CREDENTIALS.password);
          return true;
        } catch {
          setUser(null);
          return false;
        }
      }
      setUser(null);
      return false;
    } finally {
      setLoading(false);
    }
  }, [login]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (!LOGIN_BYPASS_ENABLED || loading || user) return undefined;

    const retry_timer = window.setInterval(() => {
      checkAuth();
    }, 4000);

    return () => window.clearInterval(retry_timer);
  }, [checkAuth, loading, user]);

  const logout = async () => {
    await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    setUser(null);
    if (LOGIN_BYPASS_ENABLED) {
      setLoading(true);
      await checkAuth();
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, isLoginBypassed: LOGIN_BYPASS_ENABLED }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
